import I18N from '@leverege/i18n';
import { Attributes } from '@leverege/ui-attributes';
import Pairing from "./actions/Pairing.js";
import ActionsSetup from "./actions/PluginSetup.js";
import AssetPairingSelectionRenderer from "./actions/steps/actions/AssetPairingSelectionRenderer.js";
import TagPairingSelectionRenderer from "./actions/steps/actions/TagPairingSelectionRenderer.js";
const {
  t
} = I18N.ns('pairing.pairing.views');
function processRelationship(molten, relationship) {
  const {
    attribute,
    blueprint,
    parentBlueprint,
    parentRelationship,
    path
  } = relationship;
  if (attribute?.hasTag('is:pairing') && attribute.isOneToOne()) {
    const parentObjectType = parentBlueprint.type;
    const uiAttribute = Attributes.getAttribute(`${parentBlueprint.type}.${attribute.path}`, parentBlueprint.type);
    molten.addPlugin('Action', Pairing.create({
      id: `molten.${path}.pairing`,
      attribute,
      uiAttribute,
      parentRelationship,
      relationship,
      layout: {
        group: ['Pair'],
        groupIcons: ['fa fa-link fa-fw'],
        groupNames: [() => null],
        sort: 'pair.aaa',
        sectionName: t('sectionName')
      },
      matches: [{
        client: ['GroupScreen', 'ItemInfoScreen', 'DataCardDetail'],
        use: 'actionBar',
        path: parentRelationship.path,
        objectType: parentObjectType
      }, {
        client: 'Main',
        use: 'headerOptions'
      }, {
        client: 'MapBoxRolloverSelectionPointer',
        use: 'contextMenu'
      }]
    }));
    molten.addPlugin('Action', Pairing.create({
      id: `molten.${path}.context.pairing`,
      attribute,
      uiAttribute,
      parentRelationship,
      relationship,
      matches: [{
        use: 'contextMenu',
        path: parentRelationship.path,
        objectType: parentObjectType,
        usedIn: '!toolbar'
      }],
      layout: {
        sort: 'pair.aaa'
      },
      appearance: {
        icon: 'fa fa-link fa-fw'
      }
    }));
    molten.addPlugin('PairingSelectionRenderer', AssetPairingSelectionRenderer.create({
      matches: {
        actionType: 'pair',
        objectType: parentBlueprint.type
      }
    }));
    molten.addPlugin('PairingSelectionRenderer', TagPairingSelectionRenderer.create({
      matches: {
        actionType: 'pair',
        objectType: blueprint.type
      }
    }));
  }
}
export default {
  install(molten) {
    molten.addPlugin('Molten.blueprintRelationshipProcessor', {
      type: 'api-pairing.PairUnpairActionCreator',
      processRelationship
    });
    ActionsSetup.install(molten);
  }
};